import { render, staticRenderFns } from "./DynamicAttributeAssociatedResourcesInputs.vue?vue&type=template&id=0f425438&"
import script from "./DynamicAttributeAssociatedResourcesInputs.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeAssociatedResourcesInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports